import React from 'react';
import { SiteSettingsForm } from './SiteSettingsForm';
import { VCreditsPage } from './VCreditsPage';
import { AdminAlerts } from './AdminAlerts';
import { AuditWorkspace } from './AuditWorkspace';
import './siteSettings.css';

export const AdminToolsPanel = ({ section, usersContent, originalsContent }) => <section className="site-admin-section" data-testid="admin-tools-panel" data-tab={section}>
  {section === 'originals' && <><SiteSettingsForm key="originals" section="originals" /><section className="site-originals-controls" data-testid="site-originals-controls"><h2 data-testid="site-originals-controls-title">Originals controls</h2>{originalsContent}</section></>}
  {section === 'users' && usersContent}
  {section === 'credits' && <VCreditsPage />}
  {section === 'alerts' && <AdminAlerts />}
  {section === 'construction' && <SiteSettingsForm key="construction" section="construction" />}
  {section === 'audit' && <AuditWorkspace />}
</section>;